import styles from "./RegisterOptions.module.css";
import Logo from "../../assets/Logo.svg";
import ShoppingBag from "../../assets/ShoppingBag.svg";
import Shop from "../../assets/Shop.svg";
import {useNavigate} from "react-router-dom";

export default function RegisterOptions() {
    const navigate = useNavigate()

    function handleClient() {
        navigate('/register')
    }

    function handleEntrepeneur() {
        navigate('/register/Entrepeneur')
    }

  return(
    <div className={styles.container}>
      <a href="/" className={styles.logo}><img className={styles.logo} src={Logo} alt="Logo" /></a>

            <div className={styles.containerOptions}>
                <h1>Quem é voce?</h1>
                <div className={styles.options}>
                    <button type="button" onClick={handleClient}>
                        <img src={ShoppingBag} alt="Shopping Bag"/>
                        <p>Comprador(a)</p>
                    </button>

                    <span>ou</span>

                    <button type="button" onClick={handleEntrepeneur}>
                        <img src={Shop} alt="Shop"/>
                        <p>Vendedor(a)</p>
                    </button>
                </div>
            </div>
        </div>
    )
}